// extracted by mini-css-extract-plugin
export default {"control":"Control_control__VMttR","button":"Control_button__7vQ81"};